module.exports = __webpack_public_path__ + "static/media/cloudComputing.43506b7a.png";